import { create } from 'zustand';
import { ProfileData } from 'types/profile';

type PlayerInformationFormState = {
  firstName: string;
  lastName: string;
  email: string;
  gender: string;
  pictureId: string;
  pictureUrl: string;
  birthDay: string | null;
  phone: string;
  address: {
    street1: string;
    street2: string;
    postalCode: string;
    city: string;
    country: string;
    state: string;
  };
  acceptedEmails: boolean;
  dexterity: string;
  handicap: number;
  category: string;
  culture: string;
  nationality: string;
  language: string;
  isInitialized: boolean;
  setFirstName: (value: string) => void;
  setLastName: (value: string) => void;
  setGender: (value: string) => void;
  setPhone: (value: string) => void;
  setStreet1: (value: string) => void;
  setStreet2: (value: string) => void;
  setPostalCode: (value: string) => void;
  setCity: (value: string) => void;
  setCountry: (value: string) => void;
  setState: (value: string) => void;
  setAcceptedEmails: (value: boolean) => void;
  setDexterity: (value: string) => void;
  setHandicap: (value: number) => void;
  setCategory: (value: string) => void;
  setCulture: (value: string) => void;
  setNationality: (value: string) => void;
  initFromProfileData: (profileData: ProfileData) => void;
};

export const usePlayerInformationFormStore = create<PlayerInformationFormState>((set) => ({
  firstName: '',
  lastName: '',
  email: '',
  gender: '',
  pictureId: '',
  pictureUrl: '',
  birthDay: null,
  phone: '',
  address: {
    street1: '',
    street2: '',
    postalCode: '',
    city: '',
    country: '',
    state: '',
  },
  acceptedEmails: false,
  dexterity: 'Unknown',
  handicap: 0,
  category: '',
  culture: '',
  nationality: '',
  language: '',
  isInitialized: false,
  setFirstName: (firstName) => set({ firstName }),
  setLastName: (lastName) => set({ lastName }),
  setEmail: (email) => set({ email }),
  setGender: (gender) => set({ gender }),
  setPictureId: (pictureId) => set({ pictureId }),
  setPictureUrl: (pictureUrl) => set({ pictureUrl }),
  setBirthDay: (birthDay) => set({ birthDay }),
  setPhone: (phone) => set({ phone }),
  setStreet1: (street1) => set((state) => ({ address: { ...state.address, street1 } })),
  setStreet2: (street2) => set((state) => ({ address: { ...state.address, street2 } })),
  setPostalCode: (postalCode) => set((state) => ({ address: { ...state.address, postalCode } })),
  setCity: (city) => set((state) => ({ address: { ...state.address, city } })),
  setCountry: (country) => set((state) => ({ address: { ...state.address, country } })),
  setState: (stateValue) => set((state) => ({ address: { ...state.address, state: stateValue } })),
  setAcceptedEmails: (acceptedEmails) => set({ acceptedEmails }),
  setDexterity: (dexterity) => set({ dexterity }),
  setHandicap: (handicap) => set({ handicap }),
  setCategory: (category) => set({ category }),
  setCulture: (culture) => set({ culture }),
  setNationality: (nationality) => set({ nationality }),
  setLanguage: (language) => set({ language }),
  initFromProfileData: (profileData) =>
    set({
      firstName: profileData.firstName ?? '',
      lastName: profileData.lastName ?? '',
      email: profileData.email ?? '',
      pictureId: profileData.pictureId ?? '',
      pictureUrl: profileData.pictureUrl ?? '',
      birthDay: profileData.birthDay ?? null,
      gender: profileData.gender ?? '',
      phone: profileData.phone ?? '',
      address: {
        street1: profileData.address.street1 ?? '',
        street2: profileData.address.street2 ?? '',
        postalCode: profileData.address.postalCode ?? '',
        city: profileData.address.city ?? '',
        country: profileData.address.country ?? '',
        state: profileData.address.state ?? '',
      },
      acceptedEmails: profileData.acceptedEmails ?? false,
      dexterity: profileData.dexterity ?? 'Unknown',
      handicap: profileData.handicap ?? 0,
      category: profileData.category ?? '',
      culture: profileData.culture ?? '',
      nationality: profileData.nationality ?? '',
      language: profileData.language ?? '',
      isInitialized: true,
    }),
}));
